// extracted by mini-css-extract-plugin
module.exports = {"title":"hrSec-module--title--3hTqI","hrItems":"hrSec-module--hrItems--2egWU","loadMore":"hrSec-module--loadMore--Nz2gF"};